
export const expertiseData = {
  title: "Our Expertise",
  subtitle: "Advanced Imaging Scans in all Radiography tests",
  areas: [
    {
      id: "2d-echo",
      name: "2D Echo",
      description: "Comprehensive heart ultrasound for cardiac assessment",
      details: "2D Echocardiography provides real-time imaging of the heart's structures and function. Using high-frequency sound waves, this non-invasive test evaluates heart chambers, valves, blood flow patterns, and overall cardiac performance. Essential for diagnosing heart conditions, monitoring treatment effectiveness, and assessing cardiac health.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/1181640041/photo/screen-of-echocardiography-machine.jpg?s=612x612&w=0&k=20&c=x1nom_UravpBrwSqzEYRAZ8ztpcGGJR7mw8JDiWlA1Q=",
      keyFeatures: [
        "Real-time heart imaging and motion",
        "Valve structure and function assessment",
        "Blood flow pattern analysis",
        "Heart chamber size and wall measurement",
        "Ejection fraction calculation",
        "Pericardial effusion detection"
      ],
      benefits: [
        "Non-invasive cardiac evaluation",
        "No radiation exposure",
        "Immediate results availability",
        "Comprehensive heart function analysis",
        "Safe for all age groups"
      ]
    },
    {
      id: "fetal-echo",
      name: "Fetal Echo",
      description: "Detailed fetal heart examination during pregnancy",
      details: "Fetal Echocardiography is a specialized ultrasound that examines the fetal heart's structure and function between 18-24 weeks of pregnancy. This detailed scan detects congenital heart defects, assesses heart rhythm, and ensures proper cardiac development, providing crucial information for pregnancy management.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/1223615268/video/image-on-the-monitor-of-a-medical-ultrasound-machine.avif?s=640x640&k=20&c=P3fGxr08ppKsRWkndlpWzdWVxXc0qR_jlzmRdU1TQzI=",
      keyFeatures: [
        "Four-chamber heart view assessment",
        "Fetal heart valve examination",
        "Blood flow through major vessels",
        "Heart rate and rhythm monitoring",
        "Structural abnormality detection"
      ],
      benefits: [
        "Early detection of congenital heart defects",
        "Safe for mother and baby",
        "Guides prenatal care planning",
        "Prepares for specialized delivery if needed",
        "Peace of mind for expecting parents"
      ]
    },
    {
      id: "limb-doppler",
      name: "Upper & Lower Limb Doppler",
      description: "Blood flow assessment in arms and legs",
      details: "Doppler Ultrasound examines blood flow through arteries and veins in the upper and lower limbs. This test detects blood clots, arterial blockages, venous insufficiency, and other vascular conditions using sound waves to visualize blood movement and vessel health.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/1138589271/photo/medical-vascular-doppler-diagnostics-of-blood-flow-in-the-vein-and-artery.jpg?s=612x612&w=0&k=20&c=BT4wHF4Mbcm2aeboXo9X5lCoSPZR-093fS0gJliFQTQ=",
      keyFeatures: [
        "Arterial and venous blood flow evaluation",
        "Deep Vein Thrombosis (DVT) detection",
        "Peripheral arterial disease assessment",
        "Blood clot identification and localization",
        "Vascular malformation evaluation"
      ],
      benefits: [
        "Non-invasive vascular assessment",
        "No radiation exposure",
        "Immediate diagnosis of blood clots",
        "Guides treatment decisions",
        "Monitors treatment effectiveness"
      ]
    },
    {
      id: "anomaly-scan",
      name: "Anomaly Scan",
      description: "Comprehensive fetal anatomical survey",
      details: "The Anomaly Scan, performed between 18-22 weeks of pregnancy, is a detailed ultrasound examination that assesses fetal development and screens for structural abnormalities. This comprehensive scan evaluates all major organs, limbs, and systems to ensure proper fetal growth and development.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/1127759868/photo/ultrasound-of-baby-in-mothers-at-hospital.jpg?s=612x612&w=0&k=20&c=H4HVWnR8ISDVeZ-72LJmMMMUaFZ2DzySzNKrI-28oeE=",
      keyFeatures: [
        "Complete fetal anatomy evaluation",
        "Brain, spine, and nervous system assessment",
        "Heart chambers and great vessels examination",
        "Organ development and placement check",
        "Limb measurement and counting",
        "Amniotic fluid volume assessment"
      ],
      benefits: [
        "Comprehensive fetal health screening",
        "Early detection of structural abnormalities",
        "Guides pregnancy management",
        "Provides reassurance to parents",
        "Helps prepare for special care needs"
      ]
    },
    {
      id: "nt-scan",
      name: "NT Scan",
      description: "First trimester screening for chromosomal abnormalities",
      details: "Nuchal Translucency Scan is a specialized ultrasound performed between 11-14 weeks of pregnancy. It measures the fluid collection at the back of the fetal neck and combines this with maternal blood markers to assess the risk of chromosomal abnormalities like Down syndrome.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/2118956058/photo/computed-tomography-of-a-lung-with-illness-fibrosis.jpg?s=612x612&w=0&k=20&c=scfqRqnmP4Dn6gh5rQuwuH6k3ARaD2SIb9Sd59r4AXo=",
      keyFeatures: [
        "Nuchal translucency thickness measurement",
        "Nasal bone assessment",
        "Fetal crown-rump length measurement",
        "Combined with maternal biochemistry",
        "Early anatomy survey"
      ],
      benefits: [
        "Early pregnancy risk assessment",
        "Non-invasive screening method",
        "High detection rate for chromosomal conditions",
        "Provides early information for decision making",
        "Safe and painless procedure"
      ]
    },
    {
      id: "obstetrics-doppler",
      name: "Obstetrics Doppler",
      description: "Blood flow assessment in pregnancy",
      details: "Obstetrics Doppler Ultrasound evaluates blood flow through umbilical cord, uterine arteries, and fetal vessels. This specialized test monitors fetal well-being, assesses placental function, and detects conditions like fetal growth restriction or pre-eclampsia.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/494084172/photo/blood-flow-in-placenta.jpg?s=612x612&w=0&k=20&c=G9z9GgU6mihvrhSt1lE4wfHhr7HIsAwnl-NR8Fl8jXA=",
      keyFeatures: [
        "Umbilical artery Doppler studies",
        "Uterine artery blood flow assessment",
        "Middle cerebral artery evaluation",
        "Fetal well-being monitoring",
        "Placental function assessment"
      ],
      benefits: [
        "Monitors fetal health and oxygenation",
        "Detects placental insufficiency early",
        "Guides high-risk pregnancy management",
        "Assesses fetal anemia risk",
        "Improves pregnancy outcomes"
      ]
    },
    {
  id: "liver-elastography",
  name: "Liver Elastography",
  description: "Advanced ultrasound technique to assess liver stiffness and fibrosis",
  details: "Liver Elastography is a non-invasive imaging technique that measures liver stiffness using ultrasound-based shear wave technology. It helps in evaluating liver fibrosis and cirrhosis without the need for a biopsy. Commonly used for chronic liver diseases such as fatty liver, hepatitis, and alcohol-related liver damage.",
  category: "sonography",
  image: "https://media.istockphoto.com/id/2219415949/photo/closeup-of-man-getting-an-fibroscan-or-ultrasound-scan-on-abdominal-by-doctor-of-the-liver.jpg?s=612x612&w=0&k=20&c=be4AivCOOUON7vYV67S3au4aHRRj51yimMV1v7YSosU=",
  keyFeatures: [
    "Quantitative liver stiffness measurement",
    "Shear wave based ultrasound technology",
    "Early detection of liver fibrosis",
    "Assessment of fatty liver disease",
    "Biopsy-free liver evaluation",
    "Quick and painless procedure"
  ],
  benefits: [
    "Completely non-invasive",
    "No radiation exposure",
    "Avoids liver biopsy risks",
    "Fast and reliable results",
    "Ideal for disease monitoring"
  ]
},
{
  id: "pelvis-3d-scan",
  name: "Pelvis 3D Scan",
  description: "High-resolution 3D ultrasound for detailed pelvic organ evaluation",
  details: "Pelvis 3D Scan provides three-dimensional visualization of pelvic organs, offering enhanced anatomical detail compared to conventional 2D imaging. It is widely used for gynecological evaluation including uterus, ovaries, endometrium, and pelvic floor assessment, helping in accurate diagnosis and treatment planning.",
  category: "sonography",
  image: "https://media.istockphoto.com/id/2192792687/photo/painful-hip-skeleton-x-ray-view-medical-concept-3d-illustration.jpg?s=612x612&w=0&k=20&c=8uIfofxQVVs_TTpGnPf-Dxz6vJnNUev-fXvwSowyZis=",
  keyFeatures: [
    "Three-dimensional pelvic imaging",
    "Detailed uterine and ovarian assessment",
    "Improved visualization of anomalies",
    "Accurate endometrial evaluation",
    "Pelvic floor assessment",
    "High diagnostic clarity"
  ],
  benefits: [
    "Enhanced diagnostic accuracy",
    "Better anatomical understanding",
    "Non-invasive and safe",
    "Improved treatment planning",
    "Useful in infertility evaluation"
  ]
},
{
  id: "2d-echo-gls",
  name: "2D Echo – GLS",
  description: "Advanced echocardiography for early detection of heart dysfunction",
  details: "2D Echo with Global Longitudinal Strain (GLS) is an advanced cardiac ultrasound technique that measures myocardial deformation. It allows early detection of subtle heart muscle dysfunction even when ejection fraction appears normal. GLS is particularly useful in cardiomyopathy, chemotherapy monitoring, and early heart failure assessment.",
  category: "sonography",
  image: "https://media.istockphoto.com/id/1184532162/photo/screen-of-echocardiography-machine.jpg?s=612x612&w=0&k=20&c=1wFer49FMbSLhaYOiZ7dmb1PS_cOUly8UJzOSxZ4UD4=",
  keyFeatures: [
    "Myocardial strain analysis",
    "Early detection of cardiac dysfunction",
    "Quantitative heart muscle assessment",
    "Advanced speckle tracking technology",
    "High sensitivity over traditional EF",
    "Ideal for chemotherapy monitoring"
  ],
  benefits: [
    "Detects heart disease at early stage",
    "Improves treatment decision-making",
    "Non-invasive and radiation-free",
    "Accurate and reproducible results",
    "Better risk stratification"
  ]
},
{
  id: "hsg",
  name: "HSG (Hysterosalpingography)",
  description: "Specialized imaging to evaluate uterus and fallopian tube patency",
  details: "Hysterosalpingography (HSG) is a diagnostic imaging procedure used to assess the uterine cavity and fallopian tube patency. A contrast dye is introduced into the uterus and X-ray imaging is performed to identify blockages, uterine abnormalities, or structural issues, commonly used in infertility evaluation.",
  category: "xray",
  image: "https://media.istockphoto.com/id/2178066978/photo/doctor-examining-x-ray-image-of-hysterosalpingography-mri-with-contrast-agent-uterine-tubes.jpg?s=612x612&w=0&k=20&c=UYJ5FidlwCCnBrCcwuQpLedopLu8vUVFn_-ukfXVwZs=",
  keyFeatures: [
    "Assessment of fallopian tube patency",
    "Evaluation of uterine cavity shape",
    "Detection of tubal blockages",
    "Contrast-based imaging technique",
    "Guided fluoroscopic imaging",
    "Essential infertility investigation"
  ],
  benefits: [
    "Accurate infertility diagnosis",
    "Identifies structural abnormalities",
    "Short and outpatient procedure",
    "Guides fertility treatment planning",
    "Widely accepted diagnostic test"
  ]
},
    {
      id: "ct-angiography",
      name: "3D CT Angiography",
      description: "Advanced 3D imaging of blood vessels",
      details: "3D CT Angiography uses computed tomography with contrast dye to create detailed three-dimensional images of blood vessels throughout the body. This advanced imaging technique detects blockages, aneurysms, dissections, and other vascular abnormalities with exceptional clarity.",
      category: "ct-scan",
      image: "https://media.istockphoto.com/id/2195869593/photo/magnetic-resonance-urography-is-a-colourful-mri-study.jpg?s=612x612&w=0&k=20&c=ACu4B-UL0_hWt3I4lod04t8eZlPte9SbzwHSY49Ssrg=",
      keyFeatures: [
        "Three-dimensional vascular reconstruction",
        "Multiplanar image reformation",
        "High-resolution vessel visualization",
        "Rapid scanning technology",
        "Comprehensive arterial and venous assessment"
      ],
      benefits: [
        "Non-invasive alternative to conventional angiography",
        "Detailed vascular anatomy visualization",
        "Quick diagnosis in emergency situations",
        "Accurate surgical planning",
        "Comprehensive vascular assessment"
      ]
    },
    {
      id: "ct-venography",
      name: "CT Venography",
      description: "Imaging of venous system for clot detection",
      details: "CT Venography specializes in imaging the venous system to detect deep vein thrombosis, venous obstructions, and vascular malformations. Using contrast-enhanced CT technology, it provides detailed visualization of veins throughout the body.",
      category: "ct-scan",
      image: "https://media.istockphoto.com/id/2211893440/photo/mrv-is-a-specialized-mri-scan-that-focuses-on-visualizing-the-veins-in-the-brain.jpg?s=612x612&w=0&k=20&c=3doGaHRjXg4mOz8T5t3H87ynlDAyUYgL-i4OHwkiJSo=",
      keyFeatures: [
        "Deep vein thrombosis detection",
        "Venous obstruction identification",
        "Venous malformation assessment",
        "Thrombus localization and characterization",
        "Comprehensive venous mapping"
      ],
      benefits: [
        "Accurate DVT diagnosis",
        "Guides anticoagulation therapy",
        "Assesses thrombus extent",
        "Non-invasive venous evaluation",
        "Emergency clot detection"
      ]
    },
    {
      id: "ct-urography",
      name: "CT Urography",
      description: "Comprehensive urinary system imaging",
      details: "CT Urography provides detailed imaging of kidneys, ureters, and bladder using contrast material and computed tomography. This test detects stones, tumors, obstructions, and other urinary tract abnormalities with high precision.",
      category: "ct-scan",
      image: "https://media.istockphoto.com/id/2195869593/photo/magnetic-resonance-urography-is-a-colourful-mri-study.jpg?s=612x612&w=0&k=20&c=ACu4B-UL0_hWt3I4lod04t8eZlPte9SbzwHSY49Ssrg=",
      keyFeatures: [
        "Multi-phase contrast imaging",
        "Kidney stone detection and characterization",
        "Urinary tract tumor assessment",
        "Obstruction localization",
        "Comprehensive urinary system evaluation"
      ],
      benefits: [
        "One-stop urinary system assessment",
        "High accuracy for stone detection",
        "Early tumor identification",
        "Guides urological treatments",
        "Comprehensive anatomical and functional information"
      ]
    },
    {
      id: "hrct",
      name: "HRCT",
      description: "High-Resolution CT for lung detail",
      details: "High-Resolution Computed Tomography (HRCT) uses thin-slice CT scanning to provide exceptionally detailed images of lung tissue. This specialized technique is ideal for evaluating interstitial lung diseases, bronchiectasis, and other pulmonary conditions.",
      category: "ct-scan",
      image: "https://media.istockphoto.com/id/1903727607/photo/multi-slice-hrct-scan-of-chest-prominent-broncho-vascular-markings-in-both-lungs-fields-no.jpg?s=612x612&w=0&k=20&c=WLwIlaaHKv8pQ1Of-S4zDaf4xfghWALELOLh28EDU1I=",
      keyFeatures: [
        "Thin-slice lung imaging (1-2 mm)",
        "Detailed lung architecture visualization",
        "Interstitial lung disease assessment",
        "Bronchiectasis pattern evaluation",
        "Lung fibrosis detection"
      ],
      benefits: [
        "Superior lung tissue detail",
        "Early detection of lung diseases",
        "Accurate disease characterization",
        "Guides treatment planning",
        "Monitors disease progression"
      ]
    },
    {
      id: "hsg",
      name: "HSG",
      description: "Hysterosalpingography for uterine evaluation",
      details: "Hysterosalpingography is a specialized X-ray procedure that examines the uterine cavity and fallopian tubes. Using contrast dye, this test evaluates uterine shape, detects abnormalities, and assesses tubal patency for fertility evaluation.",
      category: "xray",
      image: "https://media.istockphoto.com/id/2178552961/video/doctor-examining-x-ray-image-of-hysterosalpingography-mri-with-contrast-agent-uterine-tubes.avif?s=640x640&k=20&c=cV_tGcZTh8muy_icMRTytWzJZSd4ThOnSx5W4S2Zheg=",
      keyFeatures: [
        "Uterine cavity shape assessment",
        "Fallopian tube patency evaluation",
        "Intrauterine abnormality detection",
        "Tubal block identification",
        "Contrast flow monitoring"
      ],
      benefits: [
        "Essential fertility assessment",
        "Detects uterine structural issues",
        "Identifies tubal blockages",
        "Guides reproductive treatments",
        "Minimally invasive procedure"
      ]
    },
    {
      id: "xray-rgu",
      name: "X-RAY RGU",
      description: "Retrograde Urethrogram for male urethra",
      details: "Retrograde Urethrogram (RGU) is a specialized X-ray examination that evaluates the male urethra using contrast material. This test detects strictures, injuries, obstructions, and other urethral abnormalities.",
      category: "xray",
      image: "https://media.istockphoto.com/id/1975243021/photo/x-ray-rgu-and-mcu.jpg?s=612x612&w=0&k=20&c=bmeG1QuMFSLJTSnMKaJbzHB69_Bk0aK8eHAfbBnPVcI=",
      keyFeatures: [
        "Urethral anatomy visualization",
        "Stricture identification and localization",
        "Trauma assessment",
        "Obstruction evaluation",
        "Contrast flow pattern analysis"
      ],
      benefits: [
        "Detailed urethral assessment",
        "Guides urological surgery",
        "Trauma evaluation",
        "Pre-operative planning",
        "Accurate stricture localization"
      ]
    },
    {
      id: "xray-mcu",
      name: "X-RAY MCU",
      description: "Micturating Cystourethrogram for bladder function",
      details: "Micturating Cystourethrogram (MCU) examines the bladder and urethra during urination using X-ray and contrast material. This dynamic test evaluates bladder function, detects reflux, and assesses voiding abnormalities.",
      category: "xray",
      image: "https://media.istockphoto.com/id/2155681666/photo/x-ray-film-of-rgu-and-mcu-radiological-test-that-inject-dye-via-urethra-to-identify-urethral.jpg?s=612x612&w=0&k=20&c=PiJTEpzlKy1Fi5M_yVhj7zNhedBi7pK3OuxFXHjqoj4=",
      keyFeatures: [
        "Bladder filling and emptying assessment",
        "Vesicoureteral reflux detection",
        "Urethral function during voiding",
        "Bladder wall evaluation",
        "Dynamic urinary system study"
      ],
      benefits: [
        "Evaluates complete urinary function",
        "Detects urine reflux",
        "Assesses voiding disorders",
        "Pediatric urinary problem diagnosis",
        "Guides treatment planning"
      ]
    },
    {
      id: "ct-scan",
      name: "CT SCAN",
      description: "Advanced cross-sectional body imaging",
      details: "Computed Tomography (CT) Scan uses X-rays and computer technology to create detailed cross-sectional images of the body. This advanced imaging provides exceptional detail of bones, organs, blood vessels, and soft tissues for comprehensive diagnostic evaluation.",
      category: "ct-scan",
      image: "https://media.istockphoto.com/id/2149213138/photo/woman-undergoes-mri-or-ct-scan-diagnostic-vfx-animation-of-scanning.jpg?s=612x612&w=0&k=20&c=KWh97Rrh-vhrD_rl5eNEAhLsZI1OEaytbedTDcu0wKM=",
      keyFeatures: [
        "Multi-slice cross-sectional imaging",
        "3D reconstruction capabilities",
        "Rapid whole-body scanning",
        "Contrast-enhanced studies",
        "High-resolution bone and tissue detail"
      ],
      benefits: [
        "Comprehensive anatomical visualization",
        "Quick emergency diagnosis",
        "Accurate trauma assessment",
        "Guides interventions and surgeries",
        "Advanced cancer staging"
      ]
    },
    {
      id: "sonography",
      name: "SONOGRAPHY",
      description: "Ultrasound imaging for various body parts",
      details: "Sonography uses high-frequency sound waves to create real-time images of organs, tissues, and blood flow. This versatile, radiation-free imaging modality is essential for abdominal, pelvic, vascular, obstetric, and musculoskeletal evaluations.",
      category: "sonography",
      image: "https://media.istockphoto.com/id/123824128/photo/diagnostics-of-pregnancy.jpg?s=612x612&w=0&k=20&c=MM1EuKg1VIoIgaB4sTAMDxAZAws7NLPUDtX_iac_TW8=",
      keyFeatures: [
        "Real-time imaging capability",
        "Doppler blood flow assessment",
        "No radiation exposure",
        "Portable and bedside imaging",
        "Dynamic organ function evaluation"
      ],
      benefits: [
        "Completely safe with no radiation",
        "Immediate results availability",
        "Excellent for soft tissue evaluation",
        "Ideal for pregnancy monitoring",
        "Guides interventional procedures"
      ]
    },
    {
      id: "digital-xray",
      name: "DIGITAL X-RAY",
      description: "High-resolution digital radiography",
      details: "Digital X-Ray uses advanced digital sensors instead of traditional film to capture high-quality images of bones, chest, and other body parts. This technology provides instant results, lower radiation doses, and superior image quality for accurate diagnosis.",
      category: "xray",
      image: "https://media.istockphoto.com/id/642595250/photo/neurosurgeon-checking-mri-scans.jpg?s=612x612&w=0&k=20&c=XKxj-jxW9W2UqyvJkaEuJaFfve-gcrR6SDySkZSFfPo=",
      keyFeatures: [
        "Instant digital image acquisition",
        "Lower radiation dose",
        "High-resolution imaging",
        "Digital enhancement capabilities",
        "Quick results and easy sharing"
      ],
      benefits: [
        "Rapid diagnosis and treatment",
        "Reduced radiation exposure",
        "Superior image quality",
        "Easy storage and retrieval",
        "Cost-effective imaging solution"
      ]
    },
  ]
};
